import React, {useState} from 'react'
import './loginForm.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { useNavigate  } from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

const showPassword = () => {
    const check = document.getElementById('show-password');
    console.log(check.type)
    if (check.type === 'password') {
        check.type = 'text'
    }
    else {
        check.type = 'password'
    }
}

const LoginForm = () => {
    var obj = {
        username: "admin",
        password: "admin@123"
    }
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const navigate = useNavigate ();
    const handleUsername = (e)=>{
        setUsername(e.target.value);
    }
    const handlePassword = (e)=>{
        setPassword(e.target.value);
    }

    const handleSubmit = async (e) =>{
        e.preventDefault()
        if(username ===  obj.username && password ===  obj.password){
            try { window.sessionStorage.setItem('isAuthenticated', 'true'); } catch (_) {}
            navigate('/dashboard')
        }
        else{
            toast.error('username or password incorrect',{position:"top-right", theme:'colored'})
        }
    }
    return (
        <div>

            <div className="container">
                <div className="row vh-100 align-items-center">
                    <div className="col-lg-6 col-md-8 mx-auto login-box">
                        <div className="col-lg-12 login-key">
                            <i className="fa fa-key" aria-hidden="true"></i>
                        </div>
                        <div className="col-lg-12 login-title">
                            FIRMWARE
                        </div>

                        <div className="col-lg-12 login-form">
                            <div className="col-lg-12 p-4 login-form">
                                <form onSubmit = {handleSubmit}>
                                    <div className="form-group">
                                        <label className="form-control-label">USERNAME</label>
                                        <input type="text" className="form-control" name = "username" placeholder="Enter username" onChange={handleUsername} required/>
                                    </div>
                                    <div className="form-group">
                                        <label className="form-control-label">PASSWORD</label>
                                        <input type="password" className="form-control" id='show-password' name = "password" placeholder="Enter password" onChange={handlePassword} required/>
                                        <input type="checkbox" className="form-check-input" onClick={() => showPassword()}  /> show password
                                    </div>
                                    <div className="row form-button">
                                        <div className="col-lg-4">
                                           <button class="log">Login</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        <ToastContainer/>

        </div>
    )
}

export default LoginForm;